import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { getSchedule, saveSchedule } from "@/lib/syncScheduleApi";
import { errText } from "@/lib/fbLabApi";
import { SyncScheduleForm } from "./SyncScheduleForm";

export function SyncScheduleSettings() {
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { getSchedule().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const save = async (body) => {
    setSaving(true);
    try { setD(await saveSchedule(body)); toast.success("Facebook comment sync schedule saved"); } catch (e) { toast.error(errText(e)); } finally { setSaving(false); }
  };
  return (
    <section data-testid="sync-schedule-settings" className="rounded-xl border bg-white p-4 space-y-2">
      <h2 className="font-semibold flex items-center gap-2"><RefreshCw className="h-4 w-4" />Facebook comment sync schedule</h2>
      <p className="text-xs text-stone-600">Company default for every auction post. Checks speed up as each auction approaches its close (from the auction's own close time). The Chrome extension picks up changes within a minute — no reinstall. Individual auctions can override this in Facebook Lab.</p>
      <SyncScheduleForm key={JSON.stringify(d.settings)} value={d.settings} limits={d.limits} onSave={save} saving={saving} testid="sync-company" />
    </section>
  );
}
